import { render, staticRenderFns } from "./mobile_offlineversion.vue?vue&type=template&id=b61a3700&scoped=true"
import script from "./mobile_offlineversion.vue?vue&type=script&lang=js"
export * from "./mobile_offlineversion.vue?vue&type=script&lang=js"
import style0 from "./mobile_offlineversion.vue?vue&type=style&index=0&id=b61a3700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a3700",
  null
  
)

export default component.exports